export default "__VITE_ASSET__BhE2yf5$__"